<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="500px" @close="close">
      <div slot="content">
        <div v-if="addFlag">
          <!--저장소 추가 영역 -->
          <el-steps :active="activeStep" finish-status="success">
            <el-step v-for="(step, index) in stepTitles" :key="index" :title="`${index + 1}.${step}`"></el-step>
          </el-steps>
          <w-index-basic-setting ref="indexBasic" v-show="activeStep === 1" @increaseActiveStep="increaseActiveStep" :indexData="indexData"></w-index-basic-setting>
          <w-index-field-setting ref="indexField" v-show="activeStep === 2" :indexData="indexData" :fieldData="fieldData" :fieldOptionData="fieldOptionData"></w-index-field-setting>
        </div>
        <div v-else>
          <!-- 수정 시 출력될 영역 -->
          <div class="title-h4 title-bar">저장소 정보</div>
          <div class="list form-list mr-b25">
            <el-form :model="indexData" ref="form" label-position="left">
              <el-form-item label="저장소 명" label-width="120px"><el-input v-model="indexData.dataindexName"></el-input></el-form-item>
              <el-form-item label="생성 주기" label-width="120px">{{creationIntervalFormat(selectedIndex.creationInterval)}}</el-form-item>
              <el-form-item label="저장소 패턴" label-width="120px">{{convertTimestampPattern(indexData)}}</el-form-item>
              <el-form-item label="보관 기간" label-width="120px">{{retentionAgeFormat(selectedIndex.retentionAge)}}</el-form-item>
            </el-form>
          </div>
          <div class="mr-b25">
            <div class="title-h4 mr-b10">
              필드 정보
            </div>
            <el-table-wrapper :column-default="columnDefault" border :data="fieldData" :columns="fieldInfoColumns" :pagination="false"
              :show-custom-header="false" header-align="center" highlight-current-row>
            </el-table-wrapper>
          </div>
          <el-row>
            <el-form ref="indexForm" :model="indexData" label-position="top" :rules="rules">
              <el-form-item label="보관 기한" label-width="120px" prop="retentionAge">
                <el-input v-model="indexData.retentionAge" type="Number">
                  <span class="el-input__icon" slot="suffix">{{"(일)"}}</span>
                </el-input>
              </el-form-item>
            </el-form>
          </el-row>
        </div>
      </div>
      <el-row slot="footer" type="flex" justify="space-between">
        <div>
          <el-button size="large" v-show="activeStep === 2" @click="onPrevStep">
            <i class="fal fa-arrow-left mr-r2"></i>
            이전
          </el-button>
        </div>
        <div>
          <span v-if="addFlag">
            <el-button size="large" v-show="activeStep === 1" type="solid" @click="onNextStep">다음</el-button>
            <el-button size="large" v-show="activeStep === 2" type="solid" @click="addDataindex">저장</el-button>
          </span>
          <span v-else>
            <el-button size="large" type="solid" @click="updateDataIndex">저장</el-button>
          </span>
          <el-button @click="close" size="large" >취소</el-button>
        </div>
      </el-row>
    </w-sliding-popup>
  </div>
</template>

<script>
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import { columnDefault } from '@/constants/table';
import { cloneDeep } from 'lodash';
import IndexDataAPI from '@/api/settings/log/lms-dataindex-setting';
import msgUtil from '@/utils/message';
import querystring from 'querystring';
import WIndexBasicSetting from '../components/IndexBasicSetting';
import WIndexFieldSetting from '../components/IndexFieldSetting';

export default {
  name: 'WIndexSettingPopup',
  components: {
    WSettingSlidingPopup,
    WIndexBasicSetting,
    WIndexFieldSetting,
  },
  props: {
    selectedIndex: {
      type: Object,
    },
    addFlag: {
      type: Boolean,
    },
  },
  watch: {
    selectedIndex: {
      immediate: true,
      deep: true,
      handler() {
        this.indexData = cloneDeep(this.selectedIndex);
      },
    },
    addFlag: {
      immediate: true,
      handler() {
        this.title = (this.addFlag) ? '저장소 추가' : '저장소 수정';
        if (!this.addFlag) {
          this.indexData = cloneDeep(this.selectedIndex);
        } else {
          this.indexData = {
            dataindexName: null,
            dataindexId: null,
            creationInterval: 'H',
            retentionAge: 0,
          };
        }
      },
    },
  },
  data() {
    const validateNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('보관일을 입력하세요'));
      } else if (value < 180) {
        callback(new Error('보관일을 180일 이상으로 설정하세요'));
      }
      callback();
    };
    return {
      activeStep: 1,
      rules: {
        retentionAge: [
          { required: true, validator: validateNumber, trigger: 'blur' },
        ],
      },
      stepTitles: ['기본 설정', '필드 설정'],
      selectField: [],
      columnDefault,
      indexData: {},
      fieldData: [],
      fieldInfoColumns: [
        {
          prop: 'fieldId',
          label: '필드ID',
          scopedSlot: 'fieldId-slot',
        },
        {
          prop: 'fieldName',
          label: '필드명',
          scopedSlot: 'fieldName-slot',
        },
        {
          prop: 'fieldType',
          label: '자료형',
          scopedSlot: 'fieldType-slot',
        },
      ],
      fieldOptionData: [],
      title: '저장소 추가',
    };
  },
  methods: {
    increaseActiveStep() {
      this.activeStep = 2;
    },
    onPrevStep() {
      this.activeStep = 1;
    },
    onNextStep() {
      this.$refs.indexBasic.nextStep();
    },
    /**
     * 저장소 추가 함수
     * @author leesy918
     */
    addDataindex() {
      const payload = this.$refs.indexField.getFieldList();
      const queryString = this.indexData;

      const check = this.$refs.indexField.checkField();

      if (check) {
        IndexDataAPI.addDataindex(querystring.stringify(queryString), payload).then((respone) => {
          if (respone.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '저장소', true));
            this.$emit('loadData');
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '저장소', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '저장소', false));
          throw new Error(e);
        });
      }
    },
    /**
     * 저장소 수정 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    updateDataIndex() {
      this.$refs.indexForm.validate((check) => {
        if (check) {
          const param = [this.indexData];
          IndexDataAPI.updateDataindex(param).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장소', true));
              this.$emit('loadData');
              this.close();
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장소', false));
            throw new Error(e);
          });
        }
      });
    },
    /**
     * 생성일 포멧
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    retentionAgeFormat(data) {
      return `${data}일`;
    },
    /**
     * 생성일 포맷
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    creationIntervalFormat(data) {
      if (data === 'D') {
        return '1일';
      }
      return '1시간';
    },

    /**
     * 생성일 인덱스 패턴 포맷
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    convertTimestampPattern(data) {
      if (data.creationInterval === 'D') {
        return `${data.dataindexOrigin}-yyyy-MM-dd`;
      }
      return `${data.dataindexOrigin}-yyyy-MM-dd HH`;
    },
    /**
     * 선택한 인덱스의 필드 목록 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadIndexdataField() {
      let params = {};
      if (this.addFlag) {
        params = {
          dataindexId: null,
        };
      } else {
        params = {
          dataindexId: this.selectedIndex.dataindexId,
        };
      }
      IndexDataAPI.getDataindexField(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.fieldData = data.indexFieldList;
          this.fieldOptionData = data.indexFieldOptionList;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필드 목록', false));
        throw new Error(e);
      });
    },
    open() {
      this.$nextTick(() => {
        this.loadIndexdataField();
        this.$refs.slidingPopup.visible = true;
      });
    },
    close() {
      this.activeStep = 1;
      if (this.addFlag) {
        this.$refs.indexBasic.resetField();
      } else {
        this.$refs.indexForm.resetFields();
      }
      this.fieldData.splice(3, this.fieldData.length);
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/popup/IndexSettingPopup.vue